import { CustomCellEditorProps } from 'ag-grid-react'
import { styled } from '@mui/material'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import { ReportStatusIcon } from '../status-icon'
import { VersionReportStatus } from '../../../../../domain/entity/version-report/VersionReportVersionEntity'
import { colorPalette } from '../../../../style/colorPalette'

const OPTIONS: VersionReportStatus[] = ['SUNNY', 'CLOUDY', 'RAINY']

export const ReportStatusCellEditor = ({
  value,
  api,
  onValueChange,
}: CustomCellEditorProps<ProgressReportTableContent, VersionReportStatus>) => {
  return (
    <Panel>
      {OPTIONS.map(status => (
        <IconButton
          key={status}
          type="button"
          selected={status === value}
          onClick={() => {
            onValueChange(status)
            api.stopEditing()
          }}
        >
          <ReportStatusIcon status={status} size={24} />
        </IconButton>
      ))}
    </Panel>
  )
}

const Panel = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  gap: '2px',
  padding: '4px',
  minWidth: '90px',
  boxSizing: 'border-box',
  background: colorPalette.monotone[0],
  borderRadius: '4px',
  boxShadow: `0px 4px 16px 0px ${colorPalette.monotone[4]}80`,
})

const IconButton = styled('button')<{ selected: boolean }>(({ selected }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  padding: '4px',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  background: selected ? colorPalette.skyBlue[1] : 'transparent',
  '&:hover': {
    background: colorPalette.skyBlue[0],
  },
}))
